import React, { Component } from 'react'
import * as PropTypes from 'prop-types'
import { JobsPoolsShape } from '../../../../prop-types'
import { jobPoolsOperations } from '../../../../state/ducks/jobs-pools'
import { connect } from 'react-redux'
import { BaseFormWizard } from '../../../../assets/js/base_form_wizard'
import { JobsPoolsDataForm } from '../jobs-pools-data-form'
import { AppUI } from '../../../../assets/js/app'
import { Session } from '../../../../state/utils/session'

class JobsPoolsWizardForm extends Component {
  constructor (props) {
    super(props)

    // state
    this.state = {
      session: new Session(),
      job_pool: {
        name: '',
        stop_if_failed: false
      }
    }

    // handlers
    this.onJobsPoolsDataChange = this.onJobsPoolsDataChange.bind(this)
    this.sendData = this.sendData.bind(this)
    AppUI.initHelpers(['highlightjs'])
  }

  componentDidMount () {
    BaseFormWizard.init()
  }

  UNSAFE_componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.job_pool && 'id' in nextProps.job_pool) {
      this.setState({ job_pool: nextProps.job_pool })
    }
  }

  onJobsPoolsDataChange (name, value) {
    const jobPool = JSON.parse(JSON.stringify(this.state.job_pool))
    jobPool[name] = value
    this.setState({
      job_pool: jobPool
    })
  }

  sendData () {
    if (!this.props.isEditor) {
      const jobPool = this.state.job_pool
      jobPool.client = this.state.session.getClientSession()
      this.props.saveJobPool(this.state.job_pool)
    }
  }

  render () {
    return (
            <>
                <div className="content content-boxed">
                    <div className={' block block-themed block-opt-refresh-icon7 ' + (this.props.isLoading ? ' block-opt-refresh ' : '')}>
                        <div className="block-content">
                            {/* Simple Progress Wizard (.js-wizard-simple class is initialized in js/pages/base_forms_wizard.js) */}
                            {/* For more examples you can check out http://vadimg.com/twitter-bootstrap-wizard-example/ */}
                            <div className="js-wizard-simple block">
                                {/* Steps Progress */}
                                <div className="block-content block-content-mini block-content-full border-b">
                                    <div className="wizard-progress progress active remove-margin-b">
                                        <div className="progress-bar progress-bar-primary progress-bar-striped"
                                             role="progressbar" aria-valuenow="100" aria-valuemin="0"
                                             aria-valuemax="100"
                                             style={{ width: '0' }}>
                                        </div>
                                    </div>
                                </div>
                                {/* END Steps Progress */}

                                {/* Step Tabs */}
                                <ul className="nav nav-tabs nav-tabs-alt nav-justified">
                                    <li className="active">
                                        <a href="#simple-progress-step1" data-toggle="tab">1. Job Pool Data</a>
                                    </li>
                                    <li>
                                        <a href="#simple-progress-step2" data-toggle="tab">2. Test Job Pool</a>
                                    </li>
                                </ul>
                                {/* END Step Tabs */}

                                {/* Form */}
                                <form className="form-horizontal" action="javascript:void(0)">
                                    {/* Steps Content */}
                                    <div className="block-content tab-content" style={{ minHeight: '300px' }}>
                                        {/* Step 1 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50 active"
                                             id="simple-progress-step1">
                                            <JobsPoolsDataForm
                                                job_pool={this.state.job_pool}
                                                onChange={this.onJobsPoolsDataChange}
                                            />
                                        </div>
                                        {/* END Step 1 */}

                                        {/* Step 2 */}
                                        <div className="tab-pane fade fade-right in push-30-t push-50"
                                             id="simple-progress-step2">
                                            <div className="text-center">
                                                <span>We are working in this functionality, please continue to the next step.</span>
                                            </div>
                                        </div>
                                        {/* END Step 2 */}
                                    </div>
                                    {/* END Steps Content */}

                                    {/* Steps Navigation */}
                                    <div className="block-content block-content-mini block-content-full border-t">
                                        <div className="row">
                                            {
                                                this.props.saveJobPoolErrorResponse.error
                                                  ? <div className="col-xs-12 text-danger text-center">
                                                        {JSON.stringify(this.props.saveJobPoolErrorResponse.error)}
                                                    </div>
                                                  : null
                                            }
                                            <div className="col-xs-6">
                                                <button
                                                    className="wizard-prev btn btn-warning"
                                                    type="button"
                                                >
                                                    <i className="fa fa-arrow-circle-o-left"></i> Previous
                                                </button>
                                            </div>
                                            <div className="col-xs-6 text-right">
                                                <button
                                                    className="wizard-next btn btn-success"
                                                    type="button"
                                                >
                                                    Next <i className="fa fa-arrow-circle-o-right"></i>
                                                </button>
                                                <button
                                                    className="wizard-finish btn btn-primary"
                                                    type="button"
                                                    disabled={this.props.isLoading}
                                                    onClick={this.sendData}
                                                >
                                                    {
                                                        this.props.isLoading
                                                          ? <>
                                                                <i className="ml-1 fa fa-spinner fa-spin pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                          : <>
                                                                <i className="ml-1 si si-login pull-right"></i>
                                                                <span>Submit</span>
                                                            </>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* END Steps Navigation */}
                                </form>
                                {/* END Form */}
                            </div>
                            {/* END Simple Progress Wizard */}
                            {/* <pre className="pre-sh push"> */}
                            {/*    <code className="json"> */}
                            {/*    {JSON.stringify(this.state.job_pool)} */}
                            {/*    </code> */}
                            {/* </pre> */}
                        </div>
                    </div>
                </div>
            </>
    )
  }
}

// Set propTypes
JobsPoolsWizardForm.propTypes = {
  job_pool: JobsPoolsShape,
  saveJobPoolErrorResponse: PropTypes.object,
  isEditor: PropTypes.bool
}

// Set defaultProps
JobsPoolsWizardForm.defaultProps = {
  job_pool: {},
  saveJobPoolErrorResponse: {},
  isEditor: false
}

// mapStateToProps
const mapStateToProps = (state) => ({
  isLoading: state.jobsPools.saveJobPoolReducer.loading,
  saveJobPoolErrorResponse: state.jobsPools.saveJobPoolReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  saveJobPool: jobPoolsOperations.save
}

// Export Class
const _JobsPoolsWizardForm = connect(mapStateToProps, mapDispatchToProps)(JobsPoolsWizardForm)
export { _JobsPoolsWizardForm as JobsPoolsWizardForm }
